module.exports = __webpack_public_path__ + "img/digital-book.bb29d007.svg";